import { render, staticRenderFns } from "./OrderBook.vue?vue&type=template&id=cdae3e58&scoped=true&"
import script from "./OrderBook.vue?vue&type=script&lang=js&"
export * from "./OrderBook.vue?vue&type=script&lang=js&"
import style0 from "./OrderBook.vue?vue&type=style&index=0&id=cdae3e58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdae3e58",
  null
  
)

export default component.exports